import React from 'react';
import MobileTitleNavbar from './mobile-title-navbar';

interface Props {
  title: string;
}

const MobileSubpageTitle = ({title}: Props): React.ReactElement => (
  <MobileTitleNavbar>{title}</MobileTitleNavbar>
);

export default MobileSubpageTitle;
